import { h, Component } from 'preact';
import { Wizard } from '../../components/wizard';
import { Modal } from "@vision/preact-components/src/components/modal";

class PasswordReset extends Component {
    constructor(props) {
        super(props);
        var me = this;

        this.state = {
            recoveryToken: (new URL(window.location)).searchParams.get("recoveryToken") || '',
            userName: '',
            password: '',
            confirmPassword: '',
            pwValid: true,
            cpwValid: true,
            errMsg: '',
            errVisible: false,
            loading: false,
            success: false,
            showRequirements: false
        }

        document.addEventListener('keydown', function (e) {
            if (e.keyCode == 13) {
                if(me.state.focuskey == '') {
                    me.hideErr();
                } else {
                    me.submit(e);
                }
            }
        });
    }

    updatePassword = e => {
        if (e.target.id == "pw") {
            this.setState((prevState, props) => ({
                password: e.target.value,
                pwValid: this.validatePassword(e.target.value)
            }));
        } else {
            this.setState((prevState, props) => ({
                confirmPassword: e.target.value,
                cpwValid: this.state.password == e.target.value
            }));
        }

        this.clearErr();
    }

    componentDidMount() {
        if (!this.state.errVisible) {
            document.getElementById('pw').focus();
        }
    }

    clearErr() {
        if (this.state.errMsg || this.state.errVisible) {
            this.setState((prevState, props) => ({
                errMsg: '',
                errVisible: false
            }));
        }
    }

    focus = e => {
        if (e.type == 'blur') {
            this.setState((prevState, props) => ({
                focuskey: ''
            }));
        } else {
            this.setState((prevState, props) => ({
                focuskey: e.target.getAttribute("id")
            }));
        }
    }

    hideErr = e => {
        this.setState((prevState, props) => ({
            errVisible: false
        }));
        let selector = 'pw';
        if(this.state.pwValid && !this.state.cpwValid)
            selector = 'cpw';
        document.getElementById(selector).select();
        document.getElementById(selector).focus();
    }

    componentDidMount() {
        // Make sure this is a valid token, if not redirect to login as it won't work if it is not valid :)        
        fetch('/api/v1/user/' + this.state.recoveryToken + '/verify')
        .then(resp => {
            if (resp.status == 404) {
                //route('/',true); //THIS DOES NOT WORK
                location = '/';
            }
            return resp.json();
        }).then(data => {
            this.setState((prevState, props) => ({
                userName: data.userName
            }));

        });
    }

    validatePassword = (pw = this.state.password, provideFeedback = false) => {
        if (pw.length < 8) {
            if(provideFeedback) {
                this.setState({
                    errMsg: <span>Password must be at least 8 characters long</span>,
                    errVisible: true
                })
            }
            // console.log('pw not long enough');
            return false;
        }
        if (pw.length > 30) {
            if(provideFeedback) {
                this.setState({
                    errMsg: <span>Password must not exceed 30 characters</span>,
                    errVisible: true
                })
            }
            // console.log('pw too long');
            return false;
        }
        if (!(/[a-z]/.test(pw))) {
            if(provideFeedback) {
                this.setState({
                    errMsg: <span>Password must contain at least one lowercase letter (a-z)</span>,
                    errVisible: true
                })
            }
            // console.log('no lowercase char');
            return false;
        }
        if (!(/[A-Z]/.test(pw))) {
            if(provideFeedback) {
                this.setState({
                    errMsg: <span>Password must contain at least one uppercase letter (A-Z)</span>,
                    errVisible: true
                })
            }
            // console.log('no uppercase char');
            return false;
        }
        if (!(/[0-9]/.test(pw))) {
            if(provideFeedback) {
                this.setState({
                    errMsg: <span>Password must contain at least one number (0-9)</span>,
                    errVisible: true
                })
            }
            // console.log('no digit');
            return false;
        }
        if (!(/[$-/:-?{-~!@#"^_`\[\]\\]/.test(pw))) {
            if(provideFeedback) {
                this.setState({
                    errMsg: <span>Password must contain at least one symbol</span>,
                    errVisible: true
                })
            }
            // console.log('no symbols');
            return false;
        }
        if(provideFeedback) {
            if (pw !== this.state.confirmPassword) {
                this.setState({
                    errMsg: <span>Passwords do not match<br />Please try again.</span>,
                    errVisible: true
                })
                // console.log('pw != cpw');
                return false;
            }
        }
        return true;
    }

    submit = (e) => {
        document.getElementById('pw').blur();
        document.getElementById('cpw').blur();

        var me = this
        if (me.state.errVisible) {
            me.hideErr(e);
            return
        } else if (me.state.errMsg) {
            me.setState({errVisible: true});
            return
        }

        if (!me.validatePassword(me.state.password, true)) {
            return
        }

        let json = JSON.stringify({
            password: me.state.password,
        });
        // set loading state
        me.setState((prevState, props) => ({
            loading: true
        }));
        let logo = document.getElementsByClassName('logo-target')[0];
        logo.classList.add('loading');

        fetch('/api/v1/user/' + me.state.recoveryToken + '/update-password', {
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: json
        }).then(function (responseObj) {
            logo.classList.remove('loading');
            if (responseObj.status == 409) {
                responseObj.json().then((data) => {
                    me.setState((prevState, props) => ({
                        errMsg: <span>Password Failed<br />{data}.</span>,
                        errVisible: true,
                        loading: false,
                        password: '',
                        confirmPassword: ''
                    }));
                })

            } else if (responseObj.status == 400 || responseObj.status == 500) {
                me.setState((prevState, props) => ({
                    errMsg: <span>Unknown error, please try again.<br />If issue persists, please contact Vigilant support.</span>,
                    errVisible: true,
                    loading: false
                }));
            } else {
                me.setState((prevState, props) => ({
                    success: true,
                    errVisible: false,
                    loading: false
                }));
            }
        });
    }

    redirectToLogin = () => {
        //route('/',true); //THIS DOES NOT WORK
        location = '/';
    }

    toggleRequirements = (e) => {
        this.setState({
            showRequirements: !this.state.showRequirements
        })
        e.preventDefault();
    }

    render(props, { userName, ...state }) {
        var pwPlaceholderClasses = "floating-placeholder";
        var cpwPlaceholderClasses = "floating-placeholder";
        if (state.focuskey == 'pw') {
            pwPlaceholderClasses += ' float';
        } else if (state.focuskey == 'cpw') {
            cpwPlaceholderClasses += ' float';
        }

        if (state.password != '') {
            pwPlaceholderClasses += ' hidden';
        }
        if (state.confirmPassword != '') {
            cpwPlaceholderClasses += ' hidden';
        }

        var submitClass = (state.pwValid && state.password.length >= 8 && state.cpwValid && state.confirmPassword.length >= 8) ? 'primed' : 'locked';
        submitClass = state.errMsg ? (state.errVisible ? 'error' : 'errHidden') : submitClass;
        submitClass = state.loading ? 'loading position-spin' : submitClass;

        var outlinerClass = '';
        if(state.focuskey == 'pw')
            outlinerClass = 'email';
        if(state.focuskey == 'cpw')
            outlinerClass = 'pw';

        if (!state.pwValid) {
            outlinerClass += ' emailErr';
        }
        if (!state.cpwValid) {
            outlinerClass += ' pwErr';
        }
        return !state.success ?
        <span>
            <div style="margin-top:0;" class="wizard passwordFormAligner">  
                <div style="text-align:center;padding:1em;">
                    <h2>Welcome back, {userName}</h2>
                    Please create a new password below.
                </div>                                     
                <div id="passwordForm" style="margin-top:0;" class={state.loading ? ' loading' : ''}> 
                    <div>
                        <div class={pwPlaceholderClasses}>
                            <input maxLength="30" type="password" id="pw" value={state.password}
                                class={state.pwValid ? '' : 'error'}
                                onBlur={this.focus}
                                onFocus={this.focus}
                                onInput={this.updatePassword}
                                onChange={this.updatePassword} />
                            <label for="password" class={state.pwValid ? '' : 'error'}>Password</label>
                        </div>
                    </div>
                    <div>
                        <div class={cpwPlaceholderClasses}>
                            <input maxLength="30" type="password" id="cpw" value={state.confirmPassword}
                                class={state.cpwValid ? '' : 'error'}
                                onBlur={this.focus}
                                onFocus={this.focus}
                                onInput={this.updatePassword}
                                onChange={this.updatePassword} />
                            <label for="confirmPassword" class={state.cpwValid ? '' : 'error'}>Confirm Password</label>
                        </div>
                    </div>
                    <div id="errMsg" class={state.errVisible ? '' : 'hidden'}
                        onClick={this.hideErr}>
                        {state.errMsg}
                    </div>

                    <button type="button" onClick={this.submit}
                        class={"circle-form-button "+submitClass} />

                    <div id="input-outliner" class={outlinerClass} />
                </div> 
                <div style="text-align:center;padding:1em;">
                    <a href="#" onClick={this.toggleRequirements}>View Password Requirements</a>
                </div>  
            </div>
            <Modal
                visible={state.showRequirements}
                headerText="Password Requirements"
                bodyJSX={(
                    <span>
                        <ul>
                            <li>between 8 and 30 characters long</li>
                            <li>at least 1 lowercase letter (a-z)</li>
                            <li>at least 1 uppercase letter (A-Z)</li>
                            <li>at least 1 number (0-9)</li>
                            <li>at least 1 symbol</li>
                        </ul>
                        <p>Please, do not use the same password on multiple websites.</p>
                    </span>
                )}
                footerButtons={[
                    {label: "Close", callback: this.toggleRequirements}
                ]}
            />
        </span> :
            <Wizard isPanel={true}
                title={"Thanks, "+userName}
                next={{callback: this.redirectToLogin, label: 'Sign In'}}>
                <p style="text-align:center;margin:1em;">Your password was succesfully updated.</p>
            </Wizard>
    }
}

export default PasswordReset;